const API_BASE_URL = 'https://new.sbdemolition.online/api';

const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken');

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    });

    const text = await response.text();

    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error('Failed to parse JSON:', text);
      throw new Error('Server returned invalid response');
    }

    if (!response.ok) {
      throw new Error(data.error || data.message || `HTTP ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error('API Fetch Error:', error);
    throw error;
  }
};

export const attendanceAPI = {
  clockIn: async (data) => {
    return await apiFetch('/attendance/clock-in.php', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  clockOut: async (data) => {
    return await apiFetch('/attendance/clock-out.php', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  list: async (userId, date = null) => {
    const dateParam = date || new Date().toISOString().split('T')[0];
    return await apiFetch(`/attendance/list.php?userId=${userId}&date=${dateParam}`, {
      method: 'GET',
    });
  },
};
